//公用方法
import {
  Message
} from "element-ui";
// import http from '../../../utils/http.js';
export default {

  data() {
    return {
      device: 'desktop',
      cat: {},
      list: [],
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        title: '',
      },
      listLoading: true,
      layout: 'total, prev, pager, next',
      total: 0,
      elementLoadingText: '正在加载...',
      screenMinHeight: 700,
    }
  },
  computed: {
    routes() {
      return global.antRouter
    },
    imgpath() {
      return global.imgPath
    }

  },
  methods: {

    // 判断时pc端还是 移动端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      let device = 'desktop'
      if (flag) {
        device = 'mobile' // alert("手机端");
        // this.$router.push(item.path)
        // console.log("mmm")

        window.location.href = 'http://m.lantogis.com/'
      } else {
        device = 'desktop' // alert("pc端");
        //addMeta()
      }
      return device;
    },
    //动态添加mete
    addMeta() {
      let meta = document.createElement('meta');

      meta.content = content;

      meta.name = name;

      document.getElementsByTagName('head')[0].appendChild(meta);

    },
    //根据栏目id 获取当前栏目信息
    getCateById(id) {
      return this.looprouter(this.routes, id)
    },
    looprouter(list, id) {
      let i = 0;

      for (let item of list) {
        i++;
        if (item.id == id) {
          return item
        } else if (item.children) {
          let resu = this.looprouter(item.children, id)
          if (resu) return resu
        }

      }
      return ''
    },
    //根据文章id 获取栏目信息
    goPage(url) {
      //console.log("url", url)
      this.$router.push(url)
    },
    //默认加载数据 方法 会在具体页面定义方法进行覆盖，此处用于统一调用
    async fetchData() {
    },
    //所有默认加载的方法写在此处
    load() {
      this._isMobile()
      // 监听屏幕高度
      // window.onresize = () => {
      // 	return (() => {
      // 		this.device = this._isMobile()
      // 	})();
      // };
      this.fetchData()

    },
    //写cookies
    setCookie(name, value) {
      var Days = 30;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },
    //读取cookies
    getCookie(name) {
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
      else
        return null;
    },
    //删除cookies
    delCookie(name) {
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = getCookie(name);
      if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },
  },
  watch: {
    $route(to, from) {
      //watch  $route解决多个页面调用一个模板导致切换页面时不执行mounted方法问题：监控路由
      this.load()
    }
  },
  mounted() {
    this.load()
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/public.mixin.js